import type { ReactNode } from 'react'
import React from 'react'
import { Paragraph, Separator, H3 } from '@fs/zion-ui'

type SettingsSectionProps = {
  children: ReactNode
  heading: string
  description?: string
}

export default function SettingsSection({ heading, description, children }: SettingsSectionProps): JSX.Element {
  return (
    <>
      <H3 size="H6">{heading}</H3>
      {description && <Paragraph size="xs">{description}</Paragraph>}
      <Separator size="nano" />
      {children}
    </>
  )
}
